import { MebiLogo } from './ui/MebiLogo'
import { Button } from './ui/Button'
import { Menu } from 'lucide-react'
import { useState } from 'react'

const navItems = [
  { id: 'features', label: 'Tính năng' },
  { id: 'use-cases', label: 'Ứng dụng' },
  { id: 'pricing', label: 'Bảng giá' },
  { id: 'faq', label: 'FAQ' },
  { id: 'changelog', label: 'Changelog' },
  { id: 'download', label: 'Tải ứng dụng' },
]

function scrollToId(id: string) {
  const el = document.getElementById(id)
  if (!el) return
  const top = el.getBoundingClientRect().top + window.scrollY - 80 // offset for sticky header
  window.scrollTo({ top, behavior: 'smooth' })
}

export default function Navbar() {
  const [open, setOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-neutral-200">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
        {/* Brand */}
        <div className="flex items-center gap-3">
          <MebiLogo size="md" variant="logo-text" />
          <span className="hidden md:inline text-sm text-neutral-600">Tournament Platform</span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToId(item.id)}
              className="text-sm font-medium text-neutral-700 hover:text-mebi-yellow-600 transition-colors"
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Actions */}
        <div className="hidden md:flex items-center gap-3">
          <Button size="md">Tải ứng dụng</Button>
          <Button variant="secondary" size="md">Liên hệ</Button>
        </div>

        {/* Mobile Toggle */}
        <button onClick={() => setOpen((v) => !v)} className="md:hidden p-2 rounded-xl border border-neutral-200">
          <Menu className="w-5 h-5 text-neutral-800" />
        </button>
      </div>

      {/* Mobile Drawer */}
      {open && (
        <div className="md:hidden border-t border-neutral-200 bg-white">
          <div className="container mx-auto px-4 py-3">
            <div className="grid gap-2">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => { scrollToId(item.id); setOpen(false) }}
                  className="text-sm font-medium text-neutral-700 py-2 text-left"
                >
                  {item.label}
                </button>
              ))}
            </div>
            <div className="flex items-center gap-3 mt-3">
              <Button className="flex-1">Tải ứng dụng</Button>
              <Button variant="secondary" className="flex-1">Liên hệ</Button>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}